import ListWMDSResult from '../WMDS.Result.i18n';
import ListWSFinderResult from '../WSFinder.Result.i18n';

export default {
  props : ["agent"],
  components: { ListWMDSResult, ListWSFinderResult },
  data: () => ({ base: true, list_wsfinder_result : false, lsit_wmds_result : false, th : undefined, interval : 15, stop : false }),
  methods: {
    refresh() {
      // console.log(this.stop, this.th)
      if(!this.stop) {
        if(this.th) { this.th = undefined; }
        // console.log('webcastle log refresh', new Date()); if(this.$refs._list) { this.$refs._list.refresh(); }

        if(this.$refs.list_wsfinder_result) { this.$refs.list_wsfinder_result.$children.forEach(x => x.refresh()); }
        if(this.$refs.list_wmds_result) { this.$refs.list_wmds_result.$children.forEach(x => x.refresh()); }

        this.th = setTimeout(this.refresh, 3000 * this.interval );
        console.log("integrity", "refresh")
      }

      // interval 30 sec
    },
    detail(agent) {
      this.$router.push(`/integrity/${agent.type.toLowerCase()}`)
    },
    pause: function() { this.stop = !this.stop; this.refresh(); },
    select({ id, tag }) {
      this.list_wsfinder_result = this.lsit_wmds_result = true;
      if(!this.th) { this.refresh() }
    },
    SyncClear() {
      if(this.th) { clearTimeout(this.th); this.th = undefined; console.debug("integtiry", "sync", "clear") }
    },
  },
  watch: {
    '$route' (to, from) {
      console.log('integrity.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
  created() { console.log('integrity.vue', 'created'); },
  destroyed() { console.log('integrity.vue', 'destroyed'); this.SyncClear() },
  mounted() { console.log('integrity.vue', 'mounted'); this.select(this.$route.params); },
}
